@if (!isAddingAttribute) {
  <mat-card-content>
    <button mat-stroked-button color="primary" (click)="onAttributeAdd()">
      <mat-icon>add</mat-icon>
      <span>
        {{ 'Tenant.Alert.Template.Settings.Attributes.AddButton' | translate: locale.language }}
      </span>
    </button>
  </mat-card-content>
}
@if (isAddingAttribute) {
  <mat-card-content>
    <mat-form-field style="width: 100%">
      <mat-label>
        {{ 'Tenant.Alert.Template.Settings.Attributes.KeySelectLabel' | translate: locale.language }}
      </mat-label>
      <mat-select (selectionChange)="onAttributeKeyChange($event.value)">
        @for (key of availableAttributeKeys; track key) {
          <mat-option [value]="key">
            {{ key }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-card-content>

  <mat-card-content>
    <mat-form-field style="width: 100%">
      <mat-label>
        {{ 'Tenant.Alert.Template.Settings.Attributes.ValueSelectLabel' | translate: locale.language }}
      </mat-label>
      <mat-select
        [disabled]="availableAttributeValues.length === 0"
        (selectionChange)="onAttributeValueChange($event)"
        multiple>
        @for (value of availableAttributeValues; track value) {
          <mat-option [value]="value">
            {{ value }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-card-content>
  <mat-card-content>
    <button mat-raised-button color="primary" (click)="onAttributeSubmit()" [disabled]="!selectedAttributeValues">
      <span>
        {{ 'Tenant.Alert.Template.Settings.Attributes.SubmitButton' | translate: locale.language }}
      </span>
    </button>
    <button mat-stroked-button color="primary" (click)="onAttributeCancel()" style="margin-left: 8px">
      <span>
        {{ 'Tenant.Alert.Template.Settings.Attributes.CancelButton' | translate: locale.language }}
      </span>
    </button>
  </mat-card-content>
}

@if (workingAttributeData.length !== 0) {
  <mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="key">
      <mat-header-cell *matHeaderCellDef>
        {{ 'Tenant.Alert.Template.Settings.Attributes.TableKey' | translate: locale.language }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.key }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="value">
      <mat-header-cell *matHeaderCellDef>
        {{ 'Tenant.Alert.Template.Settings.Attributes.TableValues' | translate: locale.language }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.values }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="delete">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let element">
        <button mat-icon-button (click)="onAttributeDelete(element.key)" [attr.aria-label]="'Remove ' + element.key">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
}
